import { render, staticRenderFns } from "./screen-animation.vue?vue&type=template&id=4bdd0566"
import script from "./screen-animation.vue?vue&type=script&lang=js"
export * from "./screen-animation.vue?vue&type=script&lang=js"
import style0 from "./screen-animation.vue?vue&type=style&index=0&id=4bdd0566&prod&lang=scss"
import style1 from "./screen-animation.vue?vue&type=style&index=1&id=4bdd0566&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports